import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: 400,
    overflow: "auto",
  },
  table: {
    minWidth: 650,
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#eee",
    color: "#000",
  },
  rowCell: {
    padding: 1,
  },
  checkbox: {
    color: "#eee",
  },
  updateButton: {
    marginTop: 2,
    backgroundColor: "#4CAF50",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  searchField: {
    marginBottom: "1rem", // Add some margin to the search field
  },
}));

const ERP_Page = () => {
  const { user } = useUser();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const { ClientId } = user;

  const handleCheckboxChange = (unitCode) => {
    const updatedData = data.map((unit) => {
      if (unit.UnitCode === unitCode) {
        return { ...unit, IsChecked: !unit.IsChecked };
      }
      return unit;
    });
    setData(updatedData);
  };

  const postData = async (data) => {
    try {
      const response = await fetch(
        `${API_URL}/facility/GET_POST_In_ERP_Table/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ clientCode: ClientId, data }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Update successful :)");
      } else {
        alert("Something went wrong :(");
      }
    } catch (error) {
      console.error("Error posting data:", error);
      alert("Something went wrong :(");
    }
  };

  const handleUpdate = () => {
    const newCheckedUnits = data.filter(
      (unit) =>
        unit.IsChecked &&
        !originalData.some(
          (origUnit) =>
            origUnit.UnitCode === unit.UnitCode && origUnit.IsChecked
        )
    );

    const removedCheckedUnits = originalData.filter(
      (unit) =>
        !unit.IsChecked &&
        data.some(
          (newUnit) => newUnit.UnitCode === unit.UnitCode && newUnit.IsChecked
        )
    );
    postData(newCheckedUnits);
  };

  useEffect(() => {
    const getInitData = async () => {
      const response = await fetch(
        `${API_URL}/facility/GET_POST_In_ERP_Table/2/9/untaps009482/UnitName/1008`
      ).then((res) => res.json());
      if (response.success) {
        setData(response.data);
        setOriginalData(response.data);
      } else {
        console.log("ERROR in making API Call");
        return;
      }
    };
    getInitData();
  }, []);

  const filteredData = data.filter(
    (unit) =>
      unit.UnitCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
      unit.UnitName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 10px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          ERP DRILL
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>

        {/* Search field */}
        <TextField
          label="Search Units"
          variant="outlined"
          className={classes.searchField}
          fullWidth
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)} // Update search query
        />

        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table stickyHeader className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>Unit Code</TableCell>
                <TableCell className={classes.headerCell}>Unit Name</TableCell>
                <TableCell className={classes.headerCell}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((unit) => (
                <TableRow key={unit.UnitCode}>
                  <TableCell className={classes.rowCell}>
                    {unit.UnitCode}
                  </TableCell>
                  <TableCell className={classes.rowCell}>
                    {unit.UnitName}
                  </TableCell>
                  <TableCell className={classes.rowCell}>
                    <Box>
                      <Checkbox
                        className={classes.checkbox}
                        checked={unit.IsChecked}
                        onChange={() => handleCheckboxChange(unit.UnitCode)}
                        color="primary"
                      />
                      {unit.date && unit.date}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          variant="contained"
          className={classes.updateButton}
          onClick={handleUpdate}
        >
          Update
        </Button>
      </div>
    </>
  );
};

export default ERP_Page;
